module.exports = __webpack_public_path__ + "img/hk.962d628b.svg";